const Category= [
    {
        item: 'Small'
    },
    {
        item: 'Medium',
    },
    {
        item: 'Large',
    },
    {
        item: 'Extra Large',
    }
] 

export default Category;